var Vendd = (function (Vendd) {
    'use strict';

    Vendd.RequestReturn = (function (RequestReturn) {

        RequestReturn.Messages = (function (Messages) {


            Messages.GetReturnRequest = function (data) {
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestReturn.Messages.GetReturnRequest", data);
            };
            Messages.GetReturnRequest.className = "Vendd.RequestReturn.Messages.GetReturnRequest";


            Messages.GetReturnRequestSuccess = function (orderid) {

                Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestReturn.Messages.GetReturnRequestSuccess", orderid);
            };
            Messages.GetReturnRequestSuccess.className = "Vendd.RequestReturn.Messages.GetReturnRequestSuccess";


            Messages.GetReturnRequestFailure = function (data) {

                Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestReturn.Messages.GetReturnRequestFailure", data);
            };
            Messages.GetReturnRequestFailure.className = "Vendd.RequestReturn.Messages.GetReturnRequestFailure";

            Messages.GetReturnRequestError = function (data) {

                Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestReturn.Messages.GetReturnRequestError", data);
            };
            Messages.GetReturnRequestError.className = "Vendd.RequestReturn.Messages.GetReturnRequestError";


            Messages.SaveReturnItem = function (data) {
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestReturn.Messages.SaveReturnItem", data);
            };
            Messages.SaveReturnItem.className = "Vendd.RequestReturn.Messages.SaveReturnItem";


            Messages.SaveReturnItemSuccess = function (data) {

                Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestReturn.Messages.SaveReturnItemSuccess", data.data);
            };
            Messages.SaveReturnItemSuccess.className = "Vendd.RequestReturn.Messages.SaveReturnItemSuccess";

            Messages.SaveReturnItemFailure = function (data) {

                Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestReturn.Messages.SaveReturnItemFailure", data);
            };
            Messages.SaveReturnItemFailure.className = "Vendd.RequestReturn.Messages.SaveReturnItemFailure";
            Messages.SaveReturnItemError = function (data) {

                Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestReturn.Messages.SaveReturnItemError", data);
            };
            Messages.SaveReturnItemError.className = "Vendd.RequestReturn.Messages.SaveReturnItemError";



            Messages.DeleteReturnItem = function (data) {
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestReturn.Messages.DeleteReturnItem", data);
            };
            Messages.DeleteReturnItem.className = "Vendd.RequestReturn.Messages.DeleteReturnItem";

            Messages.DeleteReturnItemSuccess = function (data) {

                Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestReturn.Messages.DeleteReturnItemSuccess", data.data);
            };
            Messages.DeleteReturnItemSuccess.className = "Vendd.RequestReturn.Messages.DeleteReturnItemSuccess";

            Messages.DeleteReturnItemFailure = function (data) {

                Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestReturn.Messages.DeleteReturnItemFailure", data);
            };
            Messages.DeleteReturnItemFailure.className = "Vendd.RequestReturn.Messages.DeleteReturnItemFailure";
            Messages.DeleteReturnItemError = function (data) {

                Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestReturn.Messages.DeleteReturnItemError", data);
            };
            Messages.DeleteReturnItemError.className = "Vendd.RequestReturn.Messages.DeleteReturnItemError";

            Messages.SubmitOrderReturn = function (data) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.RequestReturn.Messages.SubmitOrderReturn', data);
            };
            Messages.SubmitOrderReturn.className = 'Vendd.RequestReturn.Messages.SubmitOrderReturn';


            Messages.SubmitOrderReturnSuccess = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.RequestReturn.Messages.SubmitOrderReturnSuccess', response);
            };
            Messages.SubmitOrderReturnSuccess.className = 'Vendd.RequestReturn.Messages.SubmitOrderReturnSuccess';


            Messages.SubmitOrderReturnsFailed = function (data) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.RequestReturn.Messages.SubmitOrderReturnsFailed', data);
            };
            Messages.SubmitOrderReturnsFailed.className = 'Vendd.RequestReturn.Messages.SubmitOrderReturnsFailed';

            Messages.SendReturnRequestNotification = function (data) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.RequestReturn.Messages.SendReturnRequestNotification', data);
            };
            Messages.SendReturnRequestNotification.className = 'Vendd.RequestReturn.Messages.SendReturnRequestNotification';

            Messages.CheckOrderSession = function () {
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestReturn.Messages.CheckOrderSession", null);
            };
            Messages.CheckOrderSession.className = "Vendd.RequestReturn.Messages.CheckOrderSession";

            return Messages;

        })(RequestReturn.Messages || {});

        return RequestReturn;

    })(Vendd.RequestReturn || {});

    return Vendd;

})(Vendd || {});